__turbopack_context__.v({
  "calendarHeader": "month-picker-module-scss-module__19xVPa__calendarHeader",
  "calendarMonthLabel": "month-picker-module-scss-module__19xVPa__calendarMonthLabel",
  "calendarNavButton": "month-picker-module-scss-module__19xVPa__calendarNavButton",
  "calendarNavIcon": "month-picker-module-scss-module__19xVPa__calendarNavIcon",
  "day": "month-picker-module-scss-module__19xVPa__day",
  "month": "month-picker-module-scss-module__19xVPa__month",
  "monthCell": "month-picker-module-scss-module__19xVPa__monthCell",
  "monthThead": "month-picker-module-scss-module__19xVPa__monthThead",
  "popoverContent": "month-picker-module-scss-module__19xVPa__popoverContent",
  "resetButton": "month-picker-module-scss-module__19xVPa__resetButton",
  "resetIcon": "month-picker-module-scss-module__19xVPa__resetIcon",
  "trigger": "month-picker-module-scss-module__19xVPa__trigger",
  "triggerChevron": "month-picker-module-scss-module__19xVPa__triggerChevron",
  "triggerLabel": "month-picker-module-scss-module__19xVPa__triggerLabel",
  "weekday": "month-picker-module-scss-module__19xVPa__weekday",
});
